import baseServices from '../baseServices';
import { APIError } from '../../constants/errorCode/system';
import httpHelper from '../../helpers/httpHelper';
import api from '../../common/api';

const voucherPaymentServicesV2 = {
  fetchAll: async (params) => {
    try {
      if (!params.from || !params.to) {
        delete params.from;
        delete params.to;
      }
      const queryParams = httpHelper.serialize(params);
      const url = `${api.voucherPaymentsV2.fetchAll}?${queryParams}`;
      const data = await baseServices.getDataToken(url);
      const result = await data.json();
      return result;
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
  ztlScaSuccess: async (params) => {
    try {
      const { voucherPaymentIds } = params;
      const url = api.voucherPaymentsV2.scaSuccess.replace(':voucherPaymentIds', voucherPaymentIds);
      const data = await baseServices.postDataToken(url, params);
      const result = await data.json();
      return result;
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
  payNow: async (params) => {
    try {
      const url = api.voucherPaymentsV2.payNow;
      const data = await baseServices.postDataToken(url, params);
      const result = await data.json();
      return result;
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
  singing: async (params) => {
    try {
      const { ids } = params;
      const url = api.voucherPaymentsV2.signing.replace(':ids', ids);
      const data = await baseServices.postDataToken(url, params);
      const result = await data.json();
      return result;
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
  addToPaymentList: async (params) => {
    try {
      const url = api.voucherPaymentsV2.addToPaymentList;
      const data = await baseServices.postDataToken(url, params);
      const result = await data.json();
      return result;
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
  getStatistic: async (params) => {
    try {
      const queryParams = httpHelper.serialize(params);
      const url = `${api.voucherPaymentsV2.getStatistic}?${queryParams}`;
      const data = await baseServices.getDataToken(url);
      const result = await data.json();
      return result;
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
  update: async (params) => {
    try {
      const { id } = params;
      const url = api.voucherPaymentsV2.update.replace(':id', id);
      const data = await baseServices.putDataToken(url, params);
      const result = await data.json();
      return result;
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
  delete: async (params) => {
    try {
      const url = api.voucherPaymentsV2.delete;
      const data = await baseServices.postDataToken(url, params);
      const result = await data.json();
      return result;
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
  checkDuplicate: async (params = {}) => {
    try {
      const queryParams = httpHelper.serialize(params);
      const url = api.voucherPaymentsV2.exists + `?${queryParams}`;
      const data = await baseServices.getDataToken(url);
      const result = await data.json();
      return result;
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
  handleZtlScaCallback: async (params) => {
    try {
      const { flowId } = params;
      const url = api.voucherPaymentsV2.handleZtlScaCallback.replace(':flowId', flowId);
      const data = await baseServices.postDataToken(url, params);
      const result = await data.json();
      return result;
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
  // international payment
  internationalPayNow: async (params) => {
    try {
      const url = api.voucherPaymentsV2.internaltionalPayNow;
      const data = await baseServices.postDataToken(url, params);
      const result = await data.json();
      return result;
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
  // international payment
  getLocalIban: async (params) => {
    try {
      const query = httpHelper.serialize(params);
      const url = api.voucherPaymentsV2.getLocalIbanInfo + '?' + query;
      const data = await baseServices.getDataToken(url);
      const result = await data.json();
      return result;
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
  // cancel payment
  cancelPayment: async (params) => {
    try {
      const { voucherPaymentId } = params;
      const url = api.voucherPaymentsV2.cancelPayment.replace(':id', voucherPaymentId);
      const data = await baseServices.postDataToken(url, params);
      const result = await data.json();
      return result;
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
  handleZtlCancelCallback: async (params) => {
    try {
      const { flowId } = params;
      const url = api.voucherPaymentsV2.handleZtlCancelCallback.replace(':flowId', flowId);
      const data = await baseServices.postDataToken(url, params);
      const result = await data.json();
      return result;
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
  handleZtlSignCallback: async (params) => {
    try {
      const { voucherPaymentIds } = params;
      const url = api.voucherPaymentsV2.handleZtlSignCallback.replace(':voucherPaymentIds', voucherPaymentIds);
      const data = await baseServices.postDataToken(url, params);
      const result = await data.json();
      return result;
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
  addAdvancePayment: async (params) => {
    try {
      const { companyId } = params;
      const url = api.voucherPaymentsV2.addAdvancePayment.replace(':companyId', companyId);
      const data = await baseServices.postDataToken(url, params);
      const result = await data.json();
      return result;
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
  // split payment
  splitPayment: async (params) => {
    try {
      const { id, splitCount, amount } = params;
      const url = api.voucherPaymentsV2.split.replace(':id', id);
      const data = await baseServices.postDataToken(url, { splitCount, amount });
      const result = await data.json();
      return result;
    } catch (error) {
      return { success: false, code: APIError.ConnectFail };
    }
  },
};

export default voucherPaymentServicesV2;